import { Link, useLocation } from 'react-router-dom';
import { useSeo } from '../hooks/useSeo.ts';

/**
 * Catch-all for unknown routes. Returns a 200 (we can't easily set 404 status from an SPA
 * shell), but tells crawlers via `noindex` and offers the user a clear way back to known
 * surfaces. Without this, typo'd URLs render navbar + footer + blank middle which looks
 * broken.
 */
export default function NotFoundPage() {
  const location = useLocation();
  useSeo({ title: 'Page not found', noindex: true });

  return (
    <div className="page not-found">
      <h1>Page not found</h1>
      <p className="muted">
        We couldn't find <code>{location.pathname}</code> on this site. It may have been moved,
        or the link you followed is wrong.
      </p>
      <div className="not-found-actions">
        <Link to="/" className="cta">Go home</Link>
        <Link to="/pricing" className="cta secondary">See pricing</Link>
      </div>
      <p className="muted small">
        If you reached this from a link inside EAA Proof, email{' '}
        <a href="mailto:support@eaaproof.com">support@eaaproof.com</a> and we'll fix it.
      </p>
    </div>
  );
}
